import React from 'react';
import ClayCard from "@clayui/card";
import ClayLayout from "@clayui/layout";
import { Icon } from 'common-ui-modules/dist';

const BitnamiFilterCardContent = ({ card }) => (
    <ClayCard className='mb-0 card shadow' style={{"width":"12rem"}}>
        <ClayCard.Body className='filter-card-body'>
            <ClayLayout.Row>
                <ClayLayout.Col size={5} className="d-flex justify-content-center align-items-start">
                    <Icon type={card.icon} />
                </ClayLayout.Col>
                <ClayLayout.Col size={6} className='p-0'>
                    <ClayLayout.Row>
                        <ClayCard.Description displayType='title' className='mb-1 font-weight-bold'>
                            {card.title}
                        </ClayCard.Description>
                    </ClayLayout.Row>
                    <ClayLayout.Row>
                        <ClayCard.Description displayType='subtitle'>
                            {card.category}
                        </ClayCard.Description>
                    </ClayLayout.Row>
                </ClayLayout.Col>
            </ClayLayout.Row>
        </ClayCard.Body>
    </ClayCard>
);

export default BitnamiFilterCardContent;